import { Container } from 'unstated';

import _ from 'lodash';
import { Promise } from 'es6-promise';

class SalesHistoryContainer extends Container {
  constructor(serviceContainer, props = {}) {
    super(props);

    this.serviceContainer = serviceContainer;
    this.customerService = serviceContainer.customerService;
    this.presenceService = serviceContainer.presenceService;
    this.saleHistoryService = serviceContainer.saleHistoryService;
    this.ratingService = serviceContainer.ratingService;
    this.wineMetadataService = serviceContainer.wineMetadataService;

    this.state = {
      history: undefined
    };
  }

  reset() {
    this.setState({ history: undefined });
  }

  async all(useCached = false) {
    if (useCached && !_.isNil(this.state.history)) return this.state.history; //Promise.resolve(this.state.history);

    const results = await this.saleHistoryService.fetch();
    this.state.history = results;
    return results;
  }

  get(orderId) {
    return this.all().then(
      (saleHistory) =>
        new Promise((resolve, reject) =>
          _.tap(
            _.find(saleHistory, { saleID: _.toString(orderId) }),
            (order) => {
              order ? resolve(order) : reject();
            }
          )
        )
    );
  }
}

export { SalesHistoryContainer };
